<template>
  <div class="monitor-list">
    <div class="_flex1">
      <div class="_flex1">
        <el-input placeholder="请输入关键字" v-model="input">
          <template slot="append">搜索</template>
        </el-input>
        <el-button class="btn-el" type="primary">重置</el-button>
      </div>
      <div>
        <span class="span1">上一页</span>
        <span class="span2">
          <span class="span3">1</span>
          /
          <span>4</span>
        </span>
        <span class="span1">下一页</span>
      </div>
    </div>

    <div class="listTop flex_bc">
      <div class="child1">设备名称</div>
      <div class="child1">所属分组</div>
      <div class="child1">设备位置</div>
      <div class="child1">当前音量</div>
      <div class="child3">监控地点</div>
      <div class="child3">设备状态</div>
      <div class="child1" style="margin-right: 10px">操作</div>
    </div>
    <div class="scroll-box">
      <ul>
        <li class="flex_bc" v-for="item in list" :key="item">
          <div class="child1">设备{{ item }}</div>
          <div class="child1">设备{{ item }}</div>
          <div class="child1">设备{{ item }}</div>
          <div class="child1">设备{{ item }}</div>
          <div class="child1">{{ item }}号停车场</div>
          <div
            class="child1"
            :style="{ color: item % 2 == 0 ? '#00FFA5' : '#EA5050' }"
          >
            {{ item % 2 == 0 ? '在线' : '离线' }}
          </div>
          <div class="child1 child5">
            <el-link :underline="false" type="primary" style="color: #00ffa2">
              定位
            </el-link>
            <span class="_span"></span>
            <el-link :underline="false" type="warning" @click="open">
              音量
            </el-link>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  export default {
    name: '',
    data() {
      return {
        input: '',
        list: [],
      }
    },
    computed: {},
    created() {
      this.list = Array.from({ length: 30 }, (v, i) => i + 1)
    },
    methods: {},
  }
</script>
<style lang="scss" scoped>
  .monitor-list {
    font-size: 14px;
    @mixin text_style {
      height: 50px;
      line-height: 50px;
      text-align: center;
    }
    .listTop {
      @include text_style;
      background: rgba(122, 255, 213, 0.1);
      color: #87caa8;
      margin-top: 20px;
    }
    .scroll-box {
      height: 10vh;
      overflow: auto;
    }
    ul {
      li {
        @include text_style;
        color: #fff;
      }
      li:nth-child(odd) {
        background: rgba(255, 255, 255, 0.05);
        border-bottom: 1px solid #535556;
        border-top: 1px solid #535556;
      }
    }
    .listTop,
    li {
      div {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .child1 {
      text-align: center;
      padding-left: 20px;
      flex: 0 20%;
    }
    .child2 {
      flex: 0 50%;
      margin: 0 5%;
    }
    .child3 {
      flex: 0 20%;
      text-align: center;
      padding-left: 20px;
    }

    ._flex1 {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .btn-el {
        margin-left: 10px;
        background: rgba(0, 255, 172, 0.2);
        border: 1px solid #00ff7e;
      }
      .span1 {
        display: inline-block;
        padding: 5px 20px;
        background: rgba(36, 217, 150, 0.1);
        border: 1px solid #24d996;
        border-radius: 2px;
        color: #24d996;
        cursor: pointer;
      }
      .span2 {
        color: #00ffa2;
        margin: 0 10px;
      }
      .span3 {
        color: #fff;
      }
    }
    ._span {
      display: inline-block;
      width: 2px;
      height: 12px;
      background: #525455;
      margin: 0 8px;
      position: relative;
      top: 2px;
    }
  }

  ::v-deep {
    .el-input__inner {
      border-color: #49ba90;
      background-color: #0e3428;
      color: #fff;
    }
    .el-input-group__append,
    .el-input-group__prepend {
      cursor: pointer;
      background-color: #24d996;
      color: #fff;
      border-color: #49ba90;
    }
  }
</style>
